import React from 'react';
import TextBlock from 'components/common/helpMeDecide/TextBlock';
import withCriteria from 'components/common/helpMeDecide/withCriteria';
import { RadioGroup, Guideline } from '@insurancemenu/imenu-components-lib';
import { createStyles } from 'components/common/helpMeDecide/commonCriteriaStyles';
import { observer } from 'mobx-react-lite';
import { useRootStore } from 'store/rootStore';
import { createStyles as createCustomStyles } from './styles';

const DentalCriteria2 = observer((): JSX.Element => {
  const classes = createStyles();
  const customClasses = createCustomStyles();

  // Mobx store
  const {
    browsingFilterStore: { onValueCheckboxFilterChange, getFilterValueCheckboxValue },
  } = useRootStore();
  const filterName = 'Plan Network';

  const radioButtons = [
    {
      id: 'PPO plus Premier',
      label: 'Network with both Premier and PPO dentists (lowest rates)',
      value: 'PPO plus Premier',
    },
    {
      id: 'Premier',
      label: 'Network with only Premier dentists (largest network)',
      value: 'Premier',
    },
    {
      id: 'all',
      label: 'Show me all options',
      value: 'all',
    },
  ];

  return (
    <div>
      <TextBlock
        title="Choose Your Network"
        subtitle="Delta Dental offers plans with two network options:"
        showBorder={false}
        className={customClasses.mainTitleSection}
      />
      <div className={customClasses.additionalTitleSections}>
        <TextBlock
          title="Delta Dental PPO Plus Premier Network"
          subtitle="Access to Delta Dental Premier and PPO dentists - lowest out-of-pocket costs and best benefits."
          showBorder={false}
          size="MEDIUM"
          className={customClasses.additionalSection}
        />
        <TextBlock
          title="Delta Dental Premier Network"
          subtitle="Widest choice of dentists - 90% of Iowa dentists and 80% of dentists nationwide."
          showBorder={false}
          size="MEDIUM"
          className={customClasses.additionalSection}
        />
      </div>
      <RadioGroup
        label=""
        value={getFilterValueCheckboxValue(filterName)}
        radioButtons={radioButtons}
        className={classes.radioButtonGroup}
        onChange={(e: React.ChangeEvent<HTMLInputElement>): void => {
          onValueCheckboxFilterChange(filterName, e.target.value);
        }}
      />
      <Guideline
        simpleStyles
        labels={{
          opened: 'Learn more about our flexible network choices',
          closed: 'Learn more about our flexible network choices',
        }}
        className={classes.guidelineWrapper}
        content={
          <ul className={classes.guidelineList}>
            <li className={classes.guidelineItem}>
              Employees are always free to see any dentist they wish, but will have better benefits and greater cost
              savings by going to a Delta Dental dentist.{' '}
            </li>
            <li className={classes.guidelineItem}>
              The PPO Plus Premier Network plans gives your employees access to greater benefits and lower out-of-pocket
              costs when they see a PPO dentist. Employees can also go to a Premier dentist and still have cost savings
              and coverage with these plans.
            </li>
            <li className={classes.guidelineItem}>
              The Premier Network plans provide the widest choice of dentists for your employees. You may want to
              consider a Premier only plan if you are in an area with fewer PPO dentists. Employees will still have
              benefits and save money on their dental care by going to a Premier dentist.
            </li>
            <li className={classes.guidelineItem}>
              To find a dentist in your area, please visit our website{' '}
              <a href="https://www.deltadentalia.com/find-a-provider/" rel="noreferrer" target="_blank">
                (https://www.deltadentalia.com/find-a-provider/)
              </a>
            </li>
          </ul>
        }
      />
    </div>
  );
});

export default withCriteria(DentalCriteria2, 2);
